// let host = "http://localhost:5997";
// let host = process.env.BASE_API_URL ?? "https://anystarr.com/anystarr-new-web";
let host = "/anystarr-new-web";
export let serverHost = "https://anystarr.com/anystarr-new-web";

export default host;
